import { history } from "common/services/history"
import addInvoiceUseCase from "invoices/services/addInvoiceUseCase"
import updateInvoiceDetailUseCase from "invoices/services/detail/updateInvoiceDetailUseCase"
import findClientByTask from "./sign/findClientByTask"
import updateTaskUseCase from "./updateTaskUseCase"

const addInvoiceFromTaskUseCase = async (tasks, isProforma) => {
  let idInvoice = null

  // Agrupamos tareas por cliente (dni)
  const mapTaskByClient = {}

  for (const task of tasks) {
    const { reference, description, budget, dni, deviceName, imei, refClient } = task
    const taskMap = mapTaskByClient[dni]

    const dataItem = {
      reference: reference || "",
      description: `${deviceName || "Dispositivo"} - ${description || "Averia"} - ${imei || ''} - ${refClient || ''}` || "",
      unitPrice: budget || 0,
      units: 1,
      iva: task.iva !== undefined ? task.iva !== false : true
    }

    if (!isProforma) {
      const taskToUpdate = {
        ...task,
        payed: 1,
        invoiced: 1,
      }
      await updateTaskUseCase(taskToUpdate, task)
    }

    const taskPaymentMode = Number(task?.paymentMode ?? 1)

    if (taskMap) {
      taskMap.data.push(dataItem)
      taskMap.paymentMode = Number(taskMap?.paymentMode ?? taskPaymentMode ?? 1)
    } else {
      mapTaskByClient[dni] = {
        ...task,
        data: [dataItem],
        paymentMode: taskPaymentMode
      }
    }
  }

  for (let i = 0; i < Object.keys(mapTaskByClient).length; i++) {
    const key = Object.keys(mapTaskByClient)[i]
    const { reference, dni, data, deviceName, imei, refClient, description, paymentMode, iva: taskIva } = mapTaskByClient[key]

    let invoice = {
      taskReference: reference,
      concept: `${deviceName || "Dispositivo"} - ${description || "Averia"} - ${imei || ''} - ${refClient || ''}` || "",
      paymentMode: Number(paymentMode ?? 1) // Tarjeta por defecto
    }

    if (dni) {
      const client = await findClientByTask(dni)
      // Para tareas antiguas sin iva definido, usar preferencia del cliente como fallback
      if (taskIva === undefined) {
        data.forEach(item => { item.iva = client.iva !== false })
      }
      const clientDefaultPayment = client.defaultPaymentMode
      invoice = {
        ...invoice,
        dniClient: dni,
        nameClient: client.name || "",
        codClient: client.codClient || 0,
        ...(clientDefaultPayment !== undefined && clientDefaultPayment !== null && clientDefaultPayment !== ""
          ? { paymentMode: Number(clientDefaultPayment) }
          : {})
      }
    }

    idInvoice = await addInvoiceUseCase(invoice, isProforma)
    await updateInvoiceDetailUseCase({ ...invoice, id: idInvoice }, null, { data })
  }

  const url = isProforma ? 'proformas' : 'invoices'
  const paramPro = isProforma ? '&isProforma=true' : ''
  history.push(`/${url}?id=${idInvoice}${paramPro}`)
}

export default addInvoiceFromTaskUseCase